import { RESIZE_CANVAS } from '../../action-types/ui/canvas';

export const STATE_KEY = 'canvas';

export const canvas = (state = {
  width: 0,
  height: 0,
}, action) => {
  switch (action.type) {
    case RESIZE_CANVAS:
      return Object.assign({}, state, {
        width: action.width,
        height: action.height,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/canvas.js